"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebviewUnsupportedByGoogleOAuth = isWebviewUnsupportedByGoogleOAuth;
/**
 * Check if the user agent is a user agent of a web view that is not supported by Google OAuth.
 */
function isWebviewUnsupportedByGoogleOAuth(userAgent) {
    return userAgent.includes("LinkedInApp") || userAgent.includes("FBAN/FBIOS") || userAgent.includes("Instagram");
}
